import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=6bb6b436&scoped=true&lang=pug&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"
import style1 from "./Image.vue?vue&type=style&index=1&id=6bb6b436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb6b436",
  null
  
)

export default component.exports